import React from 'react'
import Container from 'react-bootstrap/Container';
import Contactus from '../Assets/Contactus.png';
import Col from 'react-bootstrap/Col';
import Contactform from '../Components/Contactform';
function Contact() {

    return (
        <Container fluid className='m-0 p-0' >

            <div style={{ backgroundColor: '#025EA9' }} className='m-0 p-4 header-bg text-center'>
                <Container>


                    <h2 class="text-white pt-3">Contact Us</h2>



                </Container>

            </div>

            <Container>

                <div class="row mt-4">
                    <div class=" col-md-6">
                        <h2>Tell us a little about yourself, and
                            we’ll be in touch right away.</h2>

                        <img src={Contactus} alt='Employment Exchange' style={{ width: '70%' }} className='img-fluid' />

                        <Col style={{ backgroundColor: '#EBF2F7', borderLeft: 'solid 8px #F37010', fontSize: '14px' }} className=" p-3 "> {/* xs={12} makes it full width on small screens */}
                            <h3 style={{ color: '#025EA9' }}>AI Pharma Exchange HQ</h3>
                            <p>
                                8951 Cypress Waters Blvd, Suite #160,<br />
                                Coppell, TX 75019<br />
                               Email:support@aipharmaexchange.com<br />
                                www.aipharmaexchange.com.com<br />
                            </p>

                        </Col>


                    </div>
                    <div class=" col-md-6">
                        <Contactform />

                    </div>
                </div>


            </Container>

        </Container>

    );


}

export default Contact